import i18n from '@/i18n';
import store from '@/store';
import { dateFormat } from '@/utilities/constants';
import { useMixpanelConfig } from '@/utilities/mixpanel';
import fileDownload from 'js-file-download';
import moment from 'moment';
import { ref } from 'vue';
import { useToast } from 'vue-toastification';
import { fetchExportData } from '../data/fetchExportData';
const toast = useToast();
export function useUsersExport() {
    const isExporting = ref(false);
    async function exportUserList(fileType) {
        isExporting.value = true;
        useMixpanelConfig(`settings-users_clicked_export-${fileType}`);
        const date = moment().format(dateFormat);
        try {
            const exportData = await fetchExportData(fileType);
            const brandName = store.getters.selectedBrand?.brand || i18n.global.t('settings.users.title');
            const filename = `${i18n.global.t('settings.users.title')} - ${brandName} - ${date}.${fileType}`;
            fileDownload(exportData, filename);
        }
        catch {
            toast.error(i18n.global.t('settings.users.export-error'), { timeout: 10000 });
        }
        finally {
            isExporting.value = false;
        }
    }
    return {
        isExporting,
        exportUserList,
    };
}
